module.exports = __webpack_public_path__ + "static/media/CNY_Sign_Up@2x.b71e25a3.png";